module.exports = __webpack_public_path__ + "static/media/logo.c2ad88f5.png";